import type { PluginApiKey } from '@kirin/api-client/contracts/plugin-api-keys';

export type PluginKeyStatus = 'Active' | 'Expired' | 'Revoked';

/**
 * Resolve the display status of a plugin API key.
 * - 'Revoked' if isActive is false (key was explicitly expired/deleted).
 * - 'Expired' if expiresAt is in the past.
 * - 'Active' otherwise.
 */
export function pluginKeyStatus(key: PluginApiKey): PluginKeyStatus {
  if (!key.isActive) return 'Revoked';
  if (key.expiresAt && new Date(key.expiresAt).getTime() <= Date.now()) {
    return 'Expired';
  }
  return 'Active';
}

export function isPluginKeyActive(key: PluginApiKey): boolean {
  return pluginKeyStatus(key) === 'Active';
}
